<div class="add-user-group-listing-main">
  <div class="d-flex justify-content-between align-items-center">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="back-navigation pointer-cursor"
      (click)="navigateBack()"
    />
    <div>
      <p class="build-user-group mt-2 text-center">
        <app-with-tooltip [showHelpCursor]="true"
          >{{ 'ADD_USER_GROUP' | translate }}
        </app-with-tooltip>
      </p>
    </div>

    <div class="col-1">
      <img
        src="/assets/svg/ico-cross.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-10">
      <h1 class="text-center heading2">
        {{ 'ASSIGN_A_DEVICE_GROUP' | translate }}
      </h1>
    </div>

    <div class="col-10">
      <p class="sub-heading">
        {{ 'ASSIGN_A_DEVICE_GROUP_TO' | translate }}
      </p>
      <p class="sub-heading">
        {{ ("USER_GROUP" | translate) + " - " + name }}
      </p>
    </div>
  </div>

  <form [formGroup]="formGroup">
    <div class="modal-body">
      <div
        class="w-100 h-100 d-flex flex-column justify-content-center align-items-start"
      ></div>
      <div class="group-listing">
        <div class="scroll-container pr-2">
          <ng-container
            *ngFor="let radionButton of radionButtons; let i = index"
          >
            <div
              (click)="radioRef.click(); activate(radionButton)"
              class="checked-card mr-2"
              [class.active]="radionButton.active"
            >
              <img
                [src]="
                  radionButton.active
                    ? 'assets/svg/ico-check-circle.svg'
                    : 'assets/svg/ico-circle-check.svg'
                "
                class="check-circle"
              />
              <div class="content-box">
                <input
                  type="radio"
                  class="d-none"
                  [value]="radionButton.value"
                  #radioRef
                  formControlName="group"
                />
                <h3 class="title">{{ radionButton.label }}</h3>
                <p class="detail">
                  {{ radionButton.desc }}
                </p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          tabindex="0"
          [controlDisabled]="[PageName.Unit, CONSTANTS.UPDATE]"
          (click)="assignDeviceGroup()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
